import type { SelectModalFieldWithCustom as SelectModalFieldWithCustomType } from '../types';

export interface FieldOption {
  value: number;
  label: string;
  isDisabled: boolean;
}

export interface MockField {
  key: string;
  type: 'SingleSelectField';
  options: FieldOption[];
}

export const createDayFieldOptions = (
  customDeadlineOptions: SelectModalFieldWithCustomType['customDeadlineOptions']
): FieldOption[] =>
  customDeadlineOptions?.dayOfWeekOptions?.map((day) => ({
    value: day.value,
    label: day.label,
    isDisabled: false,
  })) || [];

export const createHourFieldOptions = (
  customDeadlineOptions: SelectModalFieldWithCustomType['customDeadlineOptions']
): FieldOption[] =>
  customDeadlineOptions?.hourOptions?.map((hour) => ({
    value: hour.value,
    label: hour.label,
    isDisabled: false,
  })) || [];

export const createMockField = (
  baseField: SelectModalFieldWithCustomType,
  keySuffix: string,
  options: FieldOption[]
): MockField => ({
  ...baseField,
  key: `${baseField.key}_${keySuffix}`,
  type: 'SingleSelectField' as const,
  options,
});
